import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';
import {FaIcon} from '../FaIcon';
import {Spinner} from '../Spinner';
import {Switch} from '../buttons/Swtich';
import {LocalStorage} from '../../utils/LocalStorage';
import {ReportContextSelector} from './ReportContextSelector';
import {ReportPreGenerationWizard} from './ReportPreGenerationWizard';
import {withTranslation} from 'react-i18next';
import './TemplatePickerModal.scss';


class TemplatePickerModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templates: [],
            loading: true,
            selectedSlug: null,
            userTemplates: [],
            selectedUserTemplateId: null,
            visibleToClients: true,
            isPublic: true,
            scope: null,
            clientData: null,
            loadingClient: false,
            showWizard: false,
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelectUserTemplate = this.handleSelectUserTemplate.bind(this);
        this.handleGenerate = this.handleGenerate.bind(this);
        this.proceedWithGenerate = this.proceedWithGenerate.bind(this);
        this.handleScopeChange = this.handleScopeChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen && this.props.clientId) {
            this.fetchTemplates();
        }
    }

    fetchTemplates() {
        this.setState({loading: true, selectedSlug: null, selectedUserTemplateId: null, userTemplates: [], visibleToClients: true, isPublic: true, scope: null, clientData: null, showWizard: false});
        new APIClient(API_URL + 'reports/templates/?client_id=' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                const templates = data.data.templates || [];
                const compatible = templates.filter(t => t.is_compatible);
                const selectedSlug = compatible.length === 1 ? compatible[0].slug : null;
                this.setState({templates, loading: false, selectedSlug}, () => {
                    if (selectedSlug) this.maybeFetchClientData(selectedSlug);
                });
            } else {
                this.setState({templates: [], loading: false});
            }
        });
        new APIClient(API_URL + 'reports/templates/user/').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({userTemplates: data.data.user_templates || []});
            }
        });
    }

    needsContext(template) {
        return template && template.allows_item_selection;
    }

    maybeFetchClientData(slug) {
        const template = this.state.templates.find(t => t.slug === slug);
        if (!this.needsContext(template) || this.state.clientData) return;
        this.setState({loadingClient: true});
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({clientData: data.data, loadingClient: false});
            } else {
                this.setState({loadingClient: false});
            }
        });
    }

    handleSelect(slug) {
        const template = this.state.templates.find(t => t.slug === slug);
        if (template && template.is_compatible) {
            this.setState({selectedSlug: slug, selectedUserTemplateId: null, scope: null}, () => {
                this.maybeFetchClientData(slug);
            });
        }
    }

    handleSelectUserTemplate(templateId) {
        this.setState({selectedUserTemplateId: templateId, selectedSlug: null, scope: null});
    }

    handleScopeChange(scope) {
        this.setState({scope});
    }

    handleGenerate() {
        const {selectedSlug, selectedUserTemplateId} = this.state;
        if (!selectedSlug && !selectedUserTemplateId) return;

        if (selectedUserTemplateId) {
            this.proceedWithGenerate();
            return;
        }

        this.setState({showWizard: true});
    }

    proceedWithGenerate() {
        const {selectedSlug, selectedUserTemplateId, visibleToClients, isPublic, scope} = this.state;
        this.setState({showWizard: false});
        if (this.props.onGenerate) {
            this.props.onGenerate(selectedSlug, visibleToClients, isPublic, scope, selectedUserTemplateId);
        }
    }

    renderTemplateCard(template) {
        const {t} = this.props;
        const {selectedSlug} = this.state;
        const isSelected = selectedSlug === template.slug;
        const isDisabled = !template.is_compatible;

        let className = 'template-card';
        if (isSelected) className += ' -selected';
        if (isDisabled) className += ' -disabled';

        return (
            <div
                key={template.slug}
                className={className}
                onClick={() => !isDisabled && this.handleSelect(template.slug)}
            >
                <div className="template-card-icon">
                    <FaIcon iconName={template.icon || 'file-chart-line'}/>
                </div>
                <div className="template-card-content">
                    <h4 className="template-card-name">{template.name}</h4>
                    <p className="template-card-description">{template.description}</p>
                    <div className="template-card-meta">
                        <span className="template-card-meta-badge">
                            <FaIcon iconName={template.data_source_level === 'AD_ACCOUNTS' ? 'bullhorn' : 'chart-pie'}/>
                            {template.data_source_level === 'AD_ACCOUNTS'
                                ? t('reports.meta_ad_accounts')
                                : t('reports.meta_bus')}
                        </span>
                        <span className="template-card-meta-scope">
                            {template.allows_item_selection
                                ? (template.data_source_level === 'AD_ACCOUNTS'
                                    ? t('reports.meta_scope_select_account')
                                    : t('reports.meta_scope_select_bu'))
                                : (template.data_source_level === 'AD_ACCOUNTS'
                                    ? t('reports.meta_scope_all_accounts')
                                    : t('reports.meta_scope_all_bus'))}
                        </span>
                    </div>
                    {isDisabled && template.incompatible_reasons.length > 0 && (
                        <p className="template-card-reason">
                            <FaIcon iconName="circle-info"/>
                            {template.incompatible_reasons[0]}
                        </p>
                    )}
                </div>
                {isSelected && (
                    <div className="template-card-check">
                        <FaIcon iconName="circle-check"/>
                    </div>
                )}
            </div>
        );
    }

    renderUserTemplateCard(ut) {
        const {t} = this.props;
        const {selectedUserTemplateId} = this.state;
        const isSelected = selectedUserTemplateId === ut.id;

        return (
            <div
                key={ut.id}
                className={`template-card ${isSelected ? '-selected' : ''}`}
                onClick={() => this.handleSelectUserTemplate(ut.id)}
            >
                <div className="template-card-icon">
                    <FaIcon iconName="file-chart-line"/>
                </div>
                <div className="template-card-content">
                    <h4 className="template-card-name">{ut.name}</h4>
                    <p className="template-card-description">{ut.description}</p>
                    <div className="template-card-meta">
                        <span className="template-card-meta-badge -custom">
                            <FaIcon iconName="pen-to-square"/>
                            {ut.is_shared ? t('templates.badge_shared') : t('templates.badge_custom')}
                        </span>
                        {ut.created_by && ut.created_by.id !== LocalStorage.fetchUserId() && (
                            <span className="template-card-meta-scope">
                                {t('templates.by_author', {name: ut.created_by.name})}
                            </span>
                        )}
                    </div>
                </div>
                {isSelected && (
                    <div className="template-card-check">
                        <FaIcon iconName="circle-check"/>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const {t, isOpen, toggle, generating} = this.props;
        const {templates, loading, selectedSlug, selectedUserTemplateId, userTemplates, clientData, loadingClient} = this.state;
        const selectedTemplate = selectedSlug ? templates.find(t => t.slug === selectedSlug) : null;
        const showContext = this.needsContext(selectedTemplate) && !selectedUserTemplateId;
        const hasSelection = !!selectedSlug || !!selectedUserTemplateId;

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="template-picker-modal">
                <ModalHeader toggle={toggle}>
                    {t('reports.select_template')}
                </ModalHeader>
                <ModalBody className="template-picker-modal-body">
                    {loading ? (
                        <div className="template-picker-loading">
                            <Spinner color="positive"/>
                        </div>
                    ) : (
                        <div className="template-picker-list">
                            {templates.length > 0 && userTemplates.length > 0 && (
                                <div className="template-picker-section-header">
                                    {t('templates.picker_section_official')}
                                </div>
                            )}
                            {templates.map(template => this.renderTemplateCard(template))}
                            {userTemplates.length > 0 && (
                                <>
                                    <div className="template-picker-section-header">
                                        {t('templates.picker_section_user')}
                                    </div>
                                    {userTemplates.map(ut => this.renderUserTemplateCard(ut))}
                                </>
                            )}
                        </div>
                    )}
                    {!loading && showContext && (
                        loadingClient ? (
                            <div className="template-picker-loading" style={{padding: '1.5em 0'}}>
                                <Spinner color="positive" size="sm"/>
                            </div>
                        ) : clientData && (
                            <ReportContextSelector
                                template={selectedTemplate}
                                adAccounts={clientData.ad_accounts || []}
                                businessUnits={clientData.business_units || []}
                                onScopeChange={this.handleScopeChange}
                            />
                        )
                    )}
                    {!loading && !LocalStorage.isClientUser() && (
                        <div className="template-picker-visibility-section">
                            <div className="template-picker-visibility-row">
                                <div className="template-picker-visibility-text">
                                    <span className="template-picker-visibility-label">{t('reports.visible_to_clients_label')}</span>
                                    <span className="template-picker-visibility-hint">{t('reports.visible_to_clients_hint')}</span>
                                </div>
                                <Switch
                                    name="visibleToClients"
                                    checked={this.state.visibleToClients}
                                    onChange={(e) => this.setState({visibleToClients: e.target.checked})}
                                    style={{margin: 0}}
                                />
                            </div>
                            <div className="template-picker-visibility-row">
                                <div className="template-picker-visibility-text">
                                    <span className="template-picker-visibility-label">{t('reports.public_link_label')}</span>
                                    <span className="template-picker-visibility-hint">{t(this.state.isPublic ? 'reports.public_link_hint' : 'reports.public_link_off_hint')}</span>
                                </div>
                                <Switch
                                    name="isPublic"
                                    checked={this.state.isPublic}
                                    onChange={(e) => this.setState({isPublic: e.target.checked})}
                                    style={{margin: 0}}
                                />
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="template-picker-modal-footer">
                    <button className="btn -negative" onClick={toggle}>
                        {t('client_reports.cancel')}
                    </button>
                    <button
                        className="btn -alt"
                        onClick={this.handleGenerate}
                        disabled={!hasSelection || generating || this.state.showWizard}
                    >
                        <FaIcon iconName="wand-magic-sparkles"/>
                        {this.state.showWizard
                            ? t('report_wizard.checking')
                            : (generating ? t('client_reports.generating') : t('reports.generate_report'))}
                    </button>
                </ModalFooter>
                {this.state.showWizard && (
                    <ReportPreGenerationWizard
                        clientId={this.props.clientId}
                        scope={this.state.scope}
                        selectedTemplate={selectedTemplate}
                        onValidationComplete={() => this.proceedWithGenerate()}
                        onCancel={() => this.setState({showWizard: false})}
                    />
                )}
            </Modal>
        );
    }
}

export const TemplatePickerModal = withTranslation()(TemplatePickerModalClass);
